<template>
<div class="contentGlobal">
    <div class="content inner contLogin">
        <b-progress  :value="100" variant="info" striped class="mt-2" />
        <div class="login boxLogin">
              <b-row  class="content"> 
            {{ message }}
        </b-row>
            <b-row>
                <b-col>
                    <!-- Create new pool -->
                    <h4>{{ $t("messages.newPool") }}</h4>
                    <form @submit.prevent="formData">
                        <b-row class="mtop10" :class="{ 'form-group--error': $v.form.node.$error }">
                            <!-- Node ID -->
                            <b-col cols="2" class="right"><label class="form__label">{{ $t("messages.nodeID") }}</label></b-col>
                            <b-col cols="10"><input class="form-control" v-model.trim="$v.form.node.$model" /></b-col>
                        </b-row>
                        <b-row class="mtop10" v-if="$v.form.$error">
                            <b-col cols="2" class="right"></b-col>
                            <b-col cols="10" v-if="!$v.form.node.required"><label>{{ $t('messages.login.error.required') }}</label> </b-col>
                            <b-col cols="10" v-if="!$v.form.node.minLength"><label class="form__label">{{ $t('messages.login.error.minLength', { field: 'Pool Node ID', value: $v.form.node.$params.minLength.min }) }} </label></b-col>
                            <b-col cols="10" v-if="!$v.form.node.maxLength"><label class="form__label">{{ $t('messages.login.error.maxLength', { field: 'Pool Node ID', value: $v.form.node.$params.maxLength.max }) }} </label></b-col>
                        </b-row>

                        <b-row class="mtop10">
                            <!-- Name -->
                            <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.login.name") }}</label></b-col>
                            <b-col cols="10"><b-form-input type="text" placeholder="Name" v-model.trim="$v.form.name.$model"></b-form-input></b-col>
                        </b-row>

                        <b-row class="mtop10" v-if="userProfile.isSuperAdmin">
                            <b-col cols="2" class="right"><label class="w100 right">Company</label></b-col>
                            <b-col cols="10">
                            <select class="form-control" :required="true" v-model="form.company">
                                <option 
                                    v-for="option in companies" :key="option.code" 
                                    v-bind:value="option.code"
                                    >{{ option.name }}
                                </option>
                            </select></b-col>
                        </b-row>

                        <b-row class="mtop10">
                            <!-- Country -->
                            <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.login.country") }}</label></b-col>
                            <b-col cols="10">
                                <!-- <b-form-input type="text" placeholder="country" v-model.trim="detailPool.form.country"></b-form-input> -->
                                <country-select class="form-control" v-model.trim="form.country" topCountry="ES" />
                            </b-col>
                        </b-row>
                        <b-row class="mtop10">
                            <!-- City -->
                            <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.city") }}</label></b-col>
                            <b-col cols="10">
                            <b-form-input type="text" placeholder="city" v-model.trim="form.city"></b-form-input></b-col>
                        </b-row>
                        <b-row class="mtop10">
                            <!-- Street -->
                            <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.city") }}</label></b-col>
                            <b-col cols="10">
                            <b-form-input type="text" placeholder="street"  v-model.trim="form.street"></b-form-input></b-col>
                        </b-row>
                         <b-row class="mtop10">
                             <!-- Zip-code -->
                            <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.zipCode") }}</label></b-col>
                            <b-col cols="10">
                            <b-form-input type="text" placeholder="zipcode"  v-model.trim="form.zipcode"></b-form-input></b-col>
                        </b-row>
                        <b-row class="mtop10">
                            <!-- Latitude -->
                            <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.latitude") }}</label></b-col>
                            <b-col cols="10">
                            <b-form-input type="text" placeholder="latitude"  v-model.trim="form.lat"></b-form-input></b-col>
                        </b-row>
                        <b-row class="mtop10">
                            <!-- Longitude -->
                            <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.longitude") }}</label></b-col>
                            <b-col cols="10">
                            <b-form-input type="text" placeholder="longitude"  v-model.trim="form.lng"></b-form-input></b-col>
                        </b-row>
                        <b-row class="mtop10" v-if="this.markers.length > 0">  
                            <b-col cols="2" class="right"><label class="w100 right"></label></b-col>
                            <b-col cols="10">
                                <map-geo :initial-pos="currentLocation" ref="mapDetail"></map-geo>
                            </b-col>
                        </b-row>
                        <!-- Add location -->
                        <button type="button" @click="$modal.show('form-map');"> {{ $t("messages.addLocation") }}<icon name="map-marker-alt"></icon></button>
                        <button type="submit" class="button" style="margin-top:15px">
                            <!-- Add pool -->
                           {{ $t("messages.addPool") }}
                        </button>
                    </form>
                </b-col>
            </b-row>
       
        </div>
    </div>
    <modal name="form-map"
        transition="nice-modal-fade"
        classes= "modal-detail"
        :width = 650
        :height = 500
        :pivot-y="0.5"
        :adaptive="true"
        :scrollable="true"
        :reset="true"
        :clickToClose="false">
        <div class="box-modal">
            <div slot="top-right">
                <b-btn @click="$modal.hide('form-map');" class="closePopup"> <icon name="times-circle"></icon> </b-btn>
            </div>
                <map-geo style="height:500px; width:650px" type="geo" v-on:onSaveLocation="onSaveLocation" :initial-pos="markers[0]"></map-geo>
        </div>
    </modal>
</div>

</template>

<script>
import { mapState} from 'vuex'
import {required, minLength, maxLength} from 'vuelidate/lib/validators';
import MapGeo from './Map-geo.vue'


export default {
    name: 'PoolNew',
    components:{ 
        MapGeo
    },
    data() {
        return {
            form: {
                node: "",
                name: "",
                country: "",
                city: "",
                street:"",
                zipcode: "",
                lat:"",
                lng:"",
            },
            markers:[],
            message: '',
            isLoading: true,
            currentLocation: {lat:0, lng:0}
        }

    },
    validations: {
        form: {
            node: {
                required,
                minLength: minLength(4),
                maxLength: maxLength(24)
            },
            name: {
                minLength: minLength(2)
            },
        }
    },

    computed: {
        ...mapState(['languages', 'companies', 'userProfile'])

    },
    methods: {
        formData() {
            this.$v.form.$touch();
            if (this.$v.form.$error){
                return
            }
           this.getPoolById();
        },
        onSaveLocation(address) {
            Object.assign(this.form, address);
            this.updateLocation();

            // this.$refs.mapDetail.setMarker(address);
            this.$modal.hide('form-map');
        },
        updateLocation() {
            this.markers = []
            let coords = {
                lat: String(this.form.lat).replace(/,/g, '.'),
                lng: String(this.form.lng).replace(/,/g, '.')
            }
            if(Number(coords.lat) != 0 && Number(coords.lng) !=0){
                this.markers.push({
                    position: coords,
                    clickable: false
                 });
                let arr = [];
                arr.push([coords.lat, coords.lng]);
                this.bounds = L.latLngBounds(arr);
                this.currentLocation = {
                    position: coords,
                    clickable: false
                 };
            }
        },
        getPoolById () {
            this.loading = true;
            this.$store.dispatch('getPoolById', {
                    'id': this.form.node
                }).then(response => {
                   if(response === null){
                      this.addPool()
                   }
                
                }, error => {
                    // Error retrieving data
                    this.message = $t("messages.retrieveDataError") 
                })
        },
        addPool() {
            this.form['active'] = true
            // Updating pool / Sending data
            this.$snotify.async( this.$t("messages.alertUpdatingPool"),  this.$t("messages.alertSendingData"), () => new Promise((resolve, reject) => {
                this.$store.dispatch('addPool', {
                    'pool': this.form
                }).then(response => {
                   resolve({
                    //    Pool added
                        title:  this.$t("messages.poolAdded"),
                        config: {
                            timeout: 1000,
                            closeOnClick: true
                        }
                    })
                    this.$router.push({ name: 'PoolDetail', params: { poolId: this.form.node } })
                }, error => {
                    reject({
                        // Error added pool
                        title:  this.$t("messages.poolAddedError") ,
                        body: error,
                        config: {
                            timeout: 3000,
                            
                            closeOnClick: true
                        }
                    })
                });
            }))
        }
    }
}
</script>

<style scoped>

.box-modal {
  background: white;
  overflow: hidden;
  width: 650px;
  height: 500px;
  border-radius: 5px;
  color: #8b8c8d;
    z-index: 10000;
}

.error {
    font-size: 12px;
    color: sienna;
}

.modal-detail {
    border-radius: 5px;
    background: #F7F7F7;
    box-shadow: 5px 5px 30px 0px rgba(46,61,73, 0.6);
    z-index: 10000;
}

</style>



// WEBPACK FOOTER //
// src/components/Pool-new.vue